import { ContentService, DcrKeyPipe, TranslationState } from '@blk/cwp-ng-framework';

import { ExposureSectorsConstants } from './constants';
import { IconFormatter } from './icon-formatter';
import { LabelFormatter } from './label-formatter';

export class SectorIconFormatter extends IconFormatter {
	public format(value: any, contentSvc?: ContentService): string {
		if (ExposureSectorsConstants.SECTORS.hasOwnProperty(value)) {
			return ExposureSectorsConstants.SECTORS[value];
		}
		return ExposureSectorsConstants.SECTORS.default;
	}
}
export class SectorLabelFormatter extends LabelFormatter {
	public static SectorDefaultDCR: any = {
		EXPOSURE_SECTOR_UNKNOWN: 'Other',
		EXPOSURE_SECTOR_BASICMATERIALS: 'Basic Materials',
		EXPOSURE_SECTOR_COMMUNICATIONSERVICES: 'Communication Services',
		EXPOSURE_SECTOR_CONSUMERCYCLICAL: 'Consumer Cyclical',
		EXPOSURE_SECTOR_CONSUMERDEFENSIVE: 'Consumer Defensive',
		EXPOSURE_SECTOR_ENERGY: 'Energy',
		EXPOSURE_SECTOR_FINANCIALSERVICES: 'Financial Services',
		EXPOSURE_SECTOR_HEALTHCARE: 'Healthcare',
		EXPOSURE_SECTOR_INDUSTRIALS: 'Industrials',
		EXPOSURE_SECTOR_TECHNOLOGY: 'Technology',
		EXPOSURE_SECTOR_REALESTATE: 'Real Estate',
		EXPOSURE_SECTOR_UTILITIES: 'Utilities',

		// Fixed Income Bond sector labels
		EXPOSURE_SECTOR_GOVERNMENT: 'Government',
		EXPOSURE_SECTOR_GOVERNMENTRELATED: 'Government',
		EXPOSURE_SECTOR_MUNICIPALTAXABLE: 'Municipal',
		EXPOSURE_SECTOR_USMUNICIPALTAXADVANTAGED: 'Municipal',
		EXPOSURE_SECTOR_CORPORATEBOND: 'Corporate',
		EXPOSURE_SECTOR_CONVERTIBLE: 'Corporate',
		EXPOSURE_SECTOR_BANKLOAN: 'Corporate',
		EXPOSURE_SECTOR_PREFERRED: 'Corporate',
		EXPOSURE_SECTOR_AGENCYMORTGAGEBACKED: 'Securitized',
		EXPOSURE_SECTOR_ASSETBACKED: 'Securitized',
		EXPOSURE_SECTOR_COMMERCIALMORTGAGEBACKED: 'Securitized',
		EXPOSURE_SECTOR_COVEREDBOND: 'Securitized',
		EXPOSURE_SECTOR_NONAGENCYRESIDENTIALMORTGAGEBACKED: 'Securitized',
		EXPOSURE_SECTOR_SWAP: 'Derivatives',
		EXPOSURE_SECTOR_OPTIONWARRANT: 'Derivatives',
		EXPOSURE_SECTOR_FUTUREFORWARD: 'Derivatives',
		EXPOSURE_SECTOR_CASHANDEQUIVALENTS: 'Cash & Equivalents',
		EXPOSURE_SECTOR_OTHER: 'Other'
	};
	public format(value: any, contentSvc?: ContentService): string | TranslationState {
		const dcrKey = new DcrKeyPipe().transform('EXPOSURE_SECTOR_' + value);
		let codeDefaultValue = value;
		if (SectorLabelFormatter.SectorDefaultDCR.hasOwnProperty(dcrKey)) {
			codeDefaultValue = SectorLabelFormatter.SectorDefaultDCR[dcrKey];
		}
		return contentSvc.get(dcrKey, codeDefaultValue);
	}
}
